import { Action, ActionOn, action } from 'easy-peasy';

export interface IProgressModel {
  stepNo: number;
  pageNo: number;
  progressError: boolean;

  setPageNo: Action<IProgressModel, number>;
  setStepNo: Action<IProgressModel, number>;
  setProgressError: Action<IProgressModel, boolean>;
}

const ProgressModel: IProgressModel = {
  stepNo: 0,
  pageNo: 0,
  progressError: false,

  setStepNo: action((state, payload: number) => {
    state.stepNo = payload;
  }),

  setPageNo: action((state, payload: number) => {
    state.pageNo = payload;
  }),

  setProgressError: action((state, payload: boolean) => {
    state.progressError = payload;
  }),
};
export default ProgressModel;
